export default __webpack_public_path__ + "static/media/invoice-logo.0db611dc.png";